
import { setTaskID as setTaskIDDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    taskID?: string;
}

export const setTaskID = ({
    taskID,
}: Props) => setTaskIDDiagram({
    taskID,
});


